<template>
  <div class="tool-detail-page white-theme pollo-layout">
    <div class="container">
      <section class="first-screen">
      <div class="breadcrumb">
        <router-link to="/">{{ $t('modelDetail.breadcrumb.home') }}</router-link>
        <span>&rsaquo;</span>
        <router-link to="/tools">{{ $t('tools.page.allTools') }}</router-link>
        <span>&rsaquo;</span>
        <span>{{ $t('tools.' + toolId + '.name') }}</span>
      </div>

      <div class="first-screen-grid"><div class="action-column">
      <div v-if="!isLoggedIn" class="login-prompt">
        <div class="login-prompt-content">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" stroke-width="1"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <h2>{{ $t('tools.detail.loginRequired') }}</h2>
          <p>{{ $t('tools.detail.loginRequiredDesc') }}</p>
          <button class="btn btn-primary" @click="goLogin">{{ $t('tools.detail.loginNow') }}</button>
        </div>
      </div>

      <div v-else class="tool-interface">
        <div
          class="tool-upload"
          @click="triggerUpload"
          @dragover.prevent
          @drop.prevent="onDrop"
        >
          <input type="file" ref="fileInput" :accept="toolConfig.accept" :multiple="toolConfig.isImageToPdf" style="display:none" @change="handleFile">
          <div v-if="!uploaded" class="upload-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" stroke-width="1"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>
            <p>{{ $t('tools.detail.clickUpload') }}{{ toolConfig.accept }}</p>
            <span v-if="toolConfig.isImageToPdf">{{ $t('tools.convert.multiImageHint') }}</span>
            <span v-else>{{ $t('tools.detail.support') }} {{ toolConfig.accept }}</span>
          </div>
          <div v-else class="upload-preview">
            <!-- 单文件预览 -->
            <template v-if="!toolConfig.isImageToPdf">
              <div class="preview-filename">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span class="filename-text">{{ uploadedFile ? uploadedFile.name : '' }}</span>
              </div>
            </template>
            <!-- 多文件列表（图片转PDF） -->
            <template v-else>
              <div class="preview-file-list">
                <div class="preview-file-item" v-for="(f, idx) in uploadedFiles" :key="idx">
                  <span class="preview-file-index">{{ idx + 1 }}</span>
                  <span class="filename-text">{{ f.name }}</span>
                  <button class="preview-file-remove" @click.stop="removeFile(idx)">&times;</button>
                </div>
              </div>
              <button class="btn btn-outline btn-sm" @click.stop="triggerUpload" style="font-size:13px;">+ {{ $t('tools.convert.addMore') }}</button>
            </template>
            <button class="btn btn-secondary" @click.stop="clearUpload">{{ $t('tools.detail.reupload') }}</button>
          </div>
        </div>

        <div class="tool-options">
          <button class="btn btn-primary btn-lg" :disabled="!uploaded || processing" @click="process">
            <svg v-if="processing" class="spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            <span v-else>{{ $t('tools.detail.process') }}</span>
          </button>
        </div>

        <div class="tool-result legacy-tool-result" v-if="processing || processed">
          <div v-if="processing" class="gen-loading">
            <div class="loading-spinner"></div>
            <p>{{ $t('tools.detail.processing') }}</p>
          </div>
          <div v-else class="tool-output">
            <div class="output-success">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              <h3>{{ $t('tools.convert.success') }}</h3>
              <p v-if="isZipResult" class="output-hint">{{ $t('tools.convert.zipHint') }}</p>
              <div class="output-actions">
                <button type="button" class="btn btn-primary" @click="downloadResult">{{ $t('tools.detail.download') }}</button>
                <button class="btn btn-secondary" @click="reset">{{ $t('tools.detail.processNew') }}</button>
              </div>
            </div>
          </div>
        </div>

      </div>

      </div><div class="showcase-column">
      <div class="tool-hero"><div class="tool-hero-info"><h1>{{ $t('tools.' + toolId + '.name') }}</h1><p class="tool-hero-desc">{{ $t('brandSeo.toolDescription', { description: $t('tools.' + toolId + '.fullDesc') }) }}</p></div></div>
      <DocFormatCover
        v-if="!processing && !processed"
        :tool-id="toolId"
        mode="demo"
        class="workspace-panel doc-workspace-panel"
      />
      <div class="processing-panel workspace-panel" v-else-if="processing"><div class="workspace-heading"><h2>{{ $t('tools.detail.processing') }}</h2></div><div class="document-processing-state"><div class="loading-spinner"></div><p>{{ uploadedFile ? uploadedFile.name : '' }}</p></div><div class="processing-track"><span></span></div></div>
      <div class="result-panel workspace-panel document-result-panel" v-else><div class="output-success"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><h3>{{ $t('tools.convert.success') }}</h3><p v-if="isZipResult" class="output-hint">{{ $t('tools.convert.zipHint') }}</p><div class="output-actions"><button type="button" class="btn btn-primary" @click="downloadResult">{{ $t('tools.detail.download') }}</button><button class="btn btn-secondary" @click="reset">{{ $t('tools.detail.processNew') }}</button></div></div></div>
      </div></div>
      </section>

      <div class="detail-section" style="margin-top:64px;">
        <h2>{{ $t('tools.detail.howToUse') }}</h2>
        <div class="steps">
          <div class="step" v-for="(step, idx) in steps" :key="idx">
            <div class="step-number">{{ idx + 1 }}</div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h2>{{ $t('tools.detail.moreTools') }}</h2>
        <div class="grid-5">
          <ToolListCard
            v-for="t in otherTools"
            :key="t.id"
            :tool-id="t.id"
            :icon="t.icon"
            :badge="t.badge"
            :to="toolDetailPath(t)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DOC_CONVERT_TOOLS, convertFile, imageToPdf } from '@/api/textin'
import { uploadFile, saveOrUpdateAIHistory, formatCreateDate } from '@/api'
import { isAuthenticated } from '@/api/auth'
var DocFormatCover = require('@/components/DocFormatCover.vue').default

var MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB

function fileToArrayBuffer(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader()
    reader.onload = function () { resolve(reader.result) }
    reader.onerror = function () { reject(new Error('读取文件失败')) }
    reader.readAsArrayBuffer(file)
  })
}

function fileToBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader()
    reader.onload = function () {
      var dataUrl = reader.result
      var base64 = dataUrl.split(',')[1]
      resolve(base64)
    }
    reader.onerror = function () { reject(new Error('读取文件失败')) }
    reader.readAsDataURL(file)
  })
}

function base64ToBlob(b64Str, mimeType) {
  var raw = b64Str.replace(/\s/g, '')
  var pad = raw.length % 4
  if (pad) raw += '===='.slice(0, 4 - pad)
  var binStr = atob(raw)
  var len = binStr.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) bytes[i] = binStr.charCodeAt(i)
  return new Blob([bytes], { type: mimeType })
}

export default {
  name: 'DocConvertDetail',
  components: { DocFormatCover },
  data: function () {
    return {
      uploaded: false,
      processing: false,
      processed: false,
      uploadedFile: null,
      uploadedFiles: [],
      resultBlob: null,
      resultFileName: '',
      processError: null
    }
  },
  computed: {
    toolId: function () {
      return this.$route.params.toolId || ''
    },
    toolConfig: function () {
      var id = this.toolId
      var meta = DOC_CONVERT_TOOLS[id] || {}
      var toolData = this.$store.getters.getToolById(id) || {}
      return {
        accept: meta.accept || '*',
        outputExt: meta.outputExt || '',
        outputType: meta.outputType || 'application/octet-stream',
        resultKey: meta.resultKey || '',
        isImageToPdf: !!meta.isImageToPdf,
        icon: toolData.icon || '📄'
      }
    },
    isLoggedIn: function () {
      return !!this.$store.state.userInfo
    },
    isZipResult: function () {
      return this.toolConfig.outputExt === '.zip'
    },
    steps: function () {
      return [
        { title: this.$t('tools.steps.upload.title'), desc: this.$t('tools.steps.upload.desc') },
        { title: this.$t('tools.steps.process.title'), desc: this.$t('tools.steps.process.desc') },
        { title: this.$t('tools.steps.download.title'), desc: this.$t('tools.steps.download.desc') }
      ]
    },
    otherTools: function () {
      var self = this
      return this.$store.state.tools.filter(function (t) {
        return t.category === 'document' && t.id !== self.toolId
      }).slice(0, 5)
    }
  },
  methods: {
    goLogin: function () {
      this.$store.dispatch('showLoginModal')
    },
    triggerUpload: function () {
      if (this.$refs.fileInput) this.$refs.fileInput.click()
    },
    onDrop: function (e) {
      var files = e.dataTransfer && e.dataTransfer.files
      if (!files || !files.length) return
      if (this.toolConfig.isImageToPdf) {
        this.addFiles(Array.prototype.slice.call(files))
      } else if (files[0]) {
        this.handleFileObj(files[0])
      }
    },
    handleFile: function (e) {
      var input = e.target
      var files = input.files
      if (!files || !files.length) {
        if (input) input.value = ''
        return
      }
      if (this.toolConfig.isImageToPdf) {
        this.addFiles(Array.prototype.slice.call(files))
      } else {
        this.handleFileObj(files[0])
      }
      if (input) input.value = ''
    },
    addFiles: function (newFiles) {
      var self = this
      this.processError = null
      newFiles.forEach(function (file) {
        if (file.size > MAX_FILE_SIZE) {
          self.processError = self.$t('tools.convert.fileTooLarge')
          return
        }
        if (!file.type || file.type.indexOf('image/') !== 0) return
        self.uploadedFiles.push(file)
      })
      if (this.uploadedFiles.length > 0) {
        this.uploaded = true
        this.processed = false
        this.resultBlob = null
      }
    },
    removeFile: function (idx) {
      this.uploadedFiles.splice(idx, 1)
      if (this.uploadedFiles.length === 0) {
        this.uploaded = false
        this.processed = false
      }
    },
    handleFileObj: function (file) {
      this.processError = null
      if (file.size > MAX_FILE_SIZE) {
        this.processError = this.$t('tools.convert.fileTooLarge')
        return
      }
      this.uploadedFile = file
      this.uploaded = true
      this.processed = false
      this.resultBlob = null
    },
    clearUpload: function () {
      this.uploaded = false
      this.uploadedFile = null
      this.uploadedFiles = []
      this.resultBlob = null
      this.processed = false
      this.processing = false
      this.processError = null
    },
    reset: function () {
      this.clearUpload()
    },
    toolDetailPath: function (t) {
      var lang = this.$route.params.lang
      if (t.category === 'document') {
        return lang ? '/' + lang + '/tools/doc-convert/' + t.id : '/tools/doc-convert/' + t.id
      }
      return lang ? '/' + lang + '/tools/' + t.id : '/tools/' + t.id
    },
    downloadResult: function () {
      if (!this.resultBlob) return
      var url = URL.createObjectURL(this.resultBlob)
      var a = document.createElement('a')
      a.href = url
      a.download = this.resultFileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    process: function () {
      var self = this
      if (this.toolConfig.isImageToPdf && this.uploadedFiles.length === 0) return
      if (!this.toolConfig.isImageToPdf && !this.uploadedFile) return
      this.processing = true
      this.processed = false
      this.processError = null

      var createDate = formatCreateDate(new Date())
      var aiName = this.$t('tools.' + this.toolId + '.name')
      var aiDesc = this.$t('tools.' + this.toolId + '.desc')
      var historyId = null

      // 1. 创建历史记录，等完成后再执行转换，确保 historyId 已赋值
      var historyPromise = saveOrUpdateAIHistory({
        aiName: aiName,
        taskId: '',
        aiDesc: aiDesc,
        state: 1,
        aiResultUrl: '',
        image_large_url: '',
        aiMediaType: 'document',
        createDate: createDate
      }).then(function (hRes) {
        historyId = hRes && (hRes.historyId != null ? hRes.historyId : null)
      }).catch(function () {})

      // 2. 等 historyId 赋值后，再执行转换
      historyPromise.then(function () {
        var convertPromise
        var config = self.toolConfig
        if (config.isImageToPdf) {
          var tasks = self.uploadedFiles.map(function (f) { return fileToBase64(f) })
          convertPromise = Promise.all(tasks).then(function (b64Array) {
            return imageToPdf(b64Array)
          })
        } else {
          convertPromise = fileToArrayBuffer(self.uploadedFile).then(function (buffer) {
            return convertFile(self.toolId, new Uint8Array(buffer))
          })
        }

        return convertPromise
      }).then(function (res) {
        var data = res && res.data
        if (!data || data.code !== 200) {
          throw new Error((data && data.message) || '转换失败')
        }

        // 3. 解析结果
        var config = self.toolConfig
        var b64Result
        if (config.resultKey) {
          // image-to-word: result.docx
          b64Result = data.result && data.result[config.resultKey]
        } else {
          b64Result = data.result
        }

        if (!b64Result) {
          throw new Error('未获取到转换结果')
        }

        var blob = base64ToBlob(b64Result, config.outputType)
        var srcFile = config.isImageToPdf ? (self.uploadedFiles[0] || {}) : self.uploadedFile
        var baseName = (srcFile.name || 'converted').replace(/\.[^.]+$/, '')
        self.resultBlob = blob
        self.resultFileName = baseName + config.outputExt
        self.processing = false
        self.processed = true

        // 4. 更新历史记录（成功）
        saveOrUpdateAIHistory({
          aiName: aiName,
          historyId: historyId,
          taskId: '',
          aiDesc: aiDesc,
          state: 2,
          aiResultUrl: '',
          image_large_url: '',
          aiMediaType: 'document',
          createDate: createDate
        }).catch(function () {})
      }).catch(function (err) {
        self.processing = false
        self.processed = false
        self.processError = self.$userFacingError(err, self.$t('common.generateFailedContactSupport'))
        // 更新历史记录（失败）
        saveOrUpdateAIHistory({
          aiName: self.$t('tools.' + self.toolId + '.name'),
          historyId: historyId,
          taskId: '',
          aiDesc: self.$t('tools.' + self.toolId + '.desc'),
          state: 3,
          message: err && err.message ? err.message : '',
          aiResultUrl: '',
          image_large_url: '',
          aiMediaType: 'document',
          createDate: createDate
        }).catch(function () {})
      })
    }
  }
}
</script>

<style scoped>
@import '../styles/toolPolloLayout.css';

@import './ModelDetailStyles.css';

.tool-detail-page { padding: 48px 0 80px; }
.breadcrumb { display: flex; align-items: center; gap: 8px; margin-bottom: 32px; font-size: 13px; color: var(--text-muted); }
.breadcrumb a { color: var(--text-secondary); }
.breadcrumb a:hover { color: var(--accent); }
.tool-hero { margin-bottom: 32px; }
.tool-hero-info { text-align: center; max-width: 640px; margin: 0 auto; }
.tool-hero-format {
  width: 280px;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  margin: 0 auto 20px;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--bg-secondary);
  border: 1px solid var(--bg-card-border);
}
.tool-icon-lg { font-size: 48px; display: block; margin-bottom: 16px; }
.tool-hero-info h1 { font-size: 36px; font-weight: 800; margin-bottom: 12px; }
.tool-hero-desc { font-size: 16px; color: var(--text-secondary); line-height: 1.7; margin-bottom: 24px; }
.login-prompt { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 24px 28px; text-align: center; margin: 32px auto 0; max-width: 680px; }
.login-prompt-content { max-width: 360px; margin: 0 auto; }
.login-prompt-content svg { display: block; margin: 0 auto; }
.login-prompt h2 { margin: 6px 0 4px; font-size: 20px; }
.login-prompt p { color: var(--text-muted); font-size: 14px; margin-bottom: 12px; }
.tool-interface { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 32px; margin: 32px auto 0; max-width: 680px; }
.tool-upload { cursor: pointer; }
.upload-placeholder { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 64px; border: 2px dashed var(--border-color); border-radius: var(--radius-lg); transition: border-color 0.2s; }
.upload-placeholder:hover { border-color: var(--accent); }
.upload-placeholder p { margin-top: 12px; font-size: 14px; color: var(--text-secondary); }
.upload-placeholder span { font-size: 12px; color: var(--text-muted); }
.upload-preview { display: flex; flex-direction: column; align-items: center; gap: 16px; }
.preview-filename { display: flex; align-items: center; gap: 10px; padding: 16px 24px; background: var(--bg-primary); border-radius: var(--radius-lg); }
.filename-text { font-size: 14px; color: var(--text-primary); max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.preview-file-list { width: 100%; max-height: 200px; overflow-y: auto; display: flex; flex-direction: column; gap: 6px; margin-bottom: 8px; }
.preview-file-item { display: flex; align-items: center; gap: 10px; padding: 8px 12px; background: var(--bg-primary); border-radius: 8px; }
.preview-file-index { width: 22px; height: 22px; border-radius: 50%; background: var(--accent); color: #fff; font-size: 12px; font-weight: 600; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.preview-file-remove { margin-left: auto; background: none; border: none; color: var(--text-muted); font-size: 18px; cursor: pointer; padding: 0 4px; line-height: 1; }
.preview-file-remove:hover { color: #ef4444; }
.tool-options { display: flex; align-items: flex-end; gap: 16px; margin-top: 12px; justify-content: center; }
.tool-result { margin-top: 32px; }
.gen-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 200px; gap: 12px; }
.loading-spinner { width: 40px; height: 40px; border: 3px solid var(--border-color); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.output-success { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px; gap: 12px; text-align: center; }
.output-success h3 { font-size: 18px; font-weight: 600; color: var(--accent); }
.output-hint { font-size: 13px; color: var(--text-muted); }
.output-actions { display: flex; gap: 12px; justify-content: center; margin-top: 8px; }
.detail-section { margin-bottom: 64px; }
.detail-section h2 { font-size: 24px; font-weight: 700; margin-bottom: 24px; }
.steps { display: flex; justify-content: center; gap: 48px; flex-wrap: wrap; }
.step { text-align: center; }
.step-number { width: 40px; height: 40px; border-radius: 50%; background: var(--accent); color: #000; display: flex; align-items: center; justify-content: center; font-weight: 700; margin: 0 auto 12px; }
.step h3 { margin-bottom: 6px; }
.step p { font-size: 13px; color: var(--text-muted); }
.spinner { animation: spin 1s linear infinite; }
@media (max-width: 768px) { .steps { grid-template-columns: repeat(2, 1fr); } }
</style>
